import React from 'react'
import get from 'lodash/get'

export default class AlignedComponent extends React.Component {
  render() {
    const padding = get(this.props, 'padding')
    return (
      <div
        style={ {
          paddingLeft: padding,
          paddingRight: padding,
          display: 'flex',
          justifyContent: 'flex-end',
        } }
      >
        { get(this.props, 'children') }
      </div>
    )
  }
}




// WEBPACK FOOTER //
// ./src/components/efficiency-resource/components/aligned-component.js